import './App.css';
import { Routes, Route } from "react-router-dom"
import Home from "./pages/Home"
import About from "./pages/About"
import Login from "./pages/Login"
import LoginPetugas from './pages/LoginPetugas'
import PenagihanDepan from './pages/Penagihan';
import HomeMobile from './pages/mobile/Home';
import HomeMobilePersonalia from './pages/mobile/Personalia/Home';
import Portal from './pages/Portal';
import NotFound404 from './pages/404';
import DashboardHome from "./pages/dashboard/Home"
import DashboardBacaMeterBelumInput from './pages/dashboard/Hublang/Cekmeter/MeterBelumInput';
import DashboardBacaMeterPotensial from './pages/dashboard/Hublang/Cekmeter/MeterPotensial';
import DashboardDataKaryawan from './pages/dashboard/DataKaryawan';
import Dashboard from './pages/Dashboard';
import DashboardAplikasiGaji from './pages/dashboard/GajiApp';
import DashboardAkun from './pages/dashboard/Akun';
import DashboardLoket from './pages/dashboard/Loket';
import DashboardCekmeter from './pages/dashboard/Cekmeter';
import DashboardPenagihan from './pages/dashboard/Penagihan';
import DashboardPenagihan2 from './pages/dashboard/Penagihan-2';
import DashboardPengaduan from './pages/dashboard/Pengaduan';

function App() {
  return (
    <>
      {/* Menu navigasi */}
      {/* Routing */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/pegawai" element={<LoginPetugas />} />
        <Route path="/penagihan-front" element={<PenagihanDepan />} />
        <Route path="/mobile" element={<HomeMobile />} />
        <Route path="/mobile/personalia" element={<HomeMobilePersonalia />} />
        <Route path="/portal" element={<Portal />} />

        <Route path="/Teknik" element= { <Home /> } />
        <Route path="*" element={ <NotFound404 /> } />
        <Route path="/dashboard" element={<Dashboard SideBar={[]} />}>
          {/* default (index) page */}
          <Route index element={ <DashboardHome />  } />
          <Route path="datakaryawan" element={<DashboardDataKaryawan />} />
          <Route path="gajiapp" element={<DashboardAplikasiGaji />} />
          <Route path="akun" element={<DashboardAkun />} />
          <Route path="loket" element={<DashboardLoket />} />
          <Route path="cekmeter" element={<DashboardCekmeter />} /> 
          <Route path="penagihan" element={<DashboardPenagihan />} />
          <Route path="penagihan-2" element={<DashboardPenagihan2 />} />
          <Route path="pengaduan" element={<DashboardPengaduan />} />
        </Route>
        <Route path="/cekmeter/belum-input" element={<DashboardBacaMeterBelumInput />} />
        <Route path="/cekmeter/meter-potensial/:ptgs_met" element={<DashboardBacaMeterPotensial />} />
      </Routes>
    </>
  );
}

export default App;
